import Tooltip from "@mui/material/Tooltip";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import reprocessScreeningIcon from "../../assets/images/reprocess-screening.png";
import { isScreeningReportReprocessing } from "../../utils/screeningScore";

export const REPORT_REPROCESSING_TOOLTIP = "Report Re-Processing";

type ReportReprocessingIndicatorProps = {
  active?: unknown;
  iconOnly?: boolean;
};

const ReportReprocessingIndicator = ({ active, iconOnly = false }: ReportReprocessingIndicatorProps) => {
  if (!isScreeningReportReprocessing(active)) {
    return null;
  }

  return (
    <Tooltip title={REPORT_REPROCESSING_TOOLTIP}>
      <span
        data-testid="report-reprocessing-indicator"
        aria-label={REPORT_REPROCESSING_TOOLTIP}
        style={{
          display: "inline-flex",
          flexDirection: iconOnly ? "row" : "column",
          alignItems: "center",
          marginLeft: 4,
          lineHeight: 1,
          cursor: "default",
          verticalAlign: "middle",
        }}
      >
        {iconOnly ? (
          <img
            src={reprocessScreeningIcon}
            alt=""
            data-testid="report-reprocessing-icon"
            width={18}
            height={18}
            style={{ width: 18, height: 18, display: "inline-block", flexShrink: 0 }}
          />
        ) : (
          <>
            <WarningAmberIcon sx={{ color: "#F9BB04", fontSize: 16 }} />
            <span style={{ fontSize: 10, color: "#8A6A00", fontWeight: 700 }}>Processing</span>
          </>
        )}
      </span>
    </Tooltip>
  );
};

export default ReportReprocessingIndicator;
